import { Box, Paper, Stack } from '@mui/material'
import { Helmet } from 'react-helmet'

const LOGO_DEFAULT_WIDTH = 800

export const ProjectLogo = ({ project }) => {
  if (!project?.logo?.url) return null
  const logoWidth = project?.logo?.width || LOGO_DEFAULT_WIDTH
  return (
    <Stack alignItems="center">
      <Box
        component="img"
        src={project?.logo?.url}
        sx={[
          {
            width: '100%',
            maxWidth: logoWidth,
          },
          logoWidth < 800
            ? {
                m: 5,
              }
            : {
                m: 0,
              },
        ]}
        alt={project?.name}
      />
    </Stack>
  )
}

export const CompanyLogo = ({ project }) => {
  if (!project?.companyLogo?.url) return null
  return (
    <Stack alignItems="center">
      <Box
        component="img"
        src={project?.companyLogo?.url}
        sx={{
          m: 5,
          width: '100%',
          maxWidth: project?.companyLogo?.width || LOGO_DEFAULT_WIDTH,
        }}
        alt={project?.name}
      />
    </Stack>
  )
}

export const LayoutComponent = ({ children, project }) => (
  <>
    <Helmet>
      <title>{project?.name || 'Rebla CRM'}</title>
    </Helmet>
    <Stack alignItems="center">
      <Stack alignItems="center">
        <Paper
          sx={{
            width: '100vw',
            maxWidth: 800,
          }}
        >
          <ProjectLogo project={project} />
          <Box sx={{ p: 3 }}>{children}</Box>
        </Paper>
        <CompanyLogo project={project} />
      </Stack>
    </Stack>
  </>
)
